module.exports = __webpack_public_path__ + "static/img/LI@3x.6d25f8b1.jpg";